import React, { Fragment } from "react";
import { Form, Input, Upload } from "antd";
import { useDispatch } from "react-redux";

import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

import IconUploadDocs from "@/components/icons/IconUploadDocs";

import "@/styles/components/upload-document-comment.scss";

// const props = {
//   name: "file",
//   multiple: true,
//   action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
//   onChange(info) {
//     const { status } = info.file;
//     if (status !== "uploading") {
//       console.log(info.file, info.fileList);
//     }
//     if (status === "done") {
//       message.success(`${info.file.name} file uploaded successfully.`);
//     } else if (status === "error") {
//       message.error(`${info.file.name} file upload failed.`);
//     }
//   },
//   onDrop(e) {
//     console.log("Dropped files", e.dataTransfer.files);
//   },
// };

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: "red" }}>*</span>}
  </>
);

const { Dragger } = Upload;
const { TextArea } = Input;

const UploadDocument = ({ isOpen = false, onSubmit, isComment = false, limit = 1 }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleFinish = (value) => {
    if (typeof onSubmit === "function") {
      form.resetFields();
      onSubmit(value);
    }
  };

  return (
    <Fragment>
      <ModalComponent isOpen={isOpen}>
        <div className="document-upload-form">
          <Form
            name="document"
            form={form}
            initialValues={{ remember: false }}
            layout="vertical"
            size="small"
            onFinish={handleFinish}
            requiredMark={customizeRequiredMark}
          >
            {limit > 0 ? (
              <Form.Item
                name="file"
                rules={[
                  {
                    required: !isComment ? true : false,
                    message: "Please select document",
                  },
                  {
                    // show file size error message
                    validator: (rule, value) => {
                      if (value && value[0]?.size) {
                        const maxFileSize = 5 * 1024 * 1024;
                        const maxSizeLabel = "5MB";
                        const fileSize = value[0].size;
                        const isSizeValid = fileSize <= maxFileSize;
                        if (!isSizeValid) {
                          return Promise.reject(`File must be smaller than ${maxSizeLabel}!`);
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Dragger
                  multiple={true}
                  maxCount={limit}
                  accept=".pdf, .doc, .docx, .xls, .xlsx , .csv, .jpg, .jpeg, .png, .heic"
                  beforeUpload={() => false}
                >
                  <p className="ant-upload-drag-icon">
                    <IconUploadDocs />
                  </p>
                  <p className="ant-upload-text">
                    Tap here to upload the <br /> document.
                  </p>
                </Dragger>
              </Form.Item>
            ) : (
              <></>
            )}

            <Form.Item name="comment" label="Add Comments">
              <TextArea
                autoSize={{ minRows: 4, maxRows: 7 }}
                style={{
                  padding: "10px",
                }}
                placeholder="Enter your comment..."
              />
            </Form.Item>

            <Form.Item>
              <div className="button">
                <ButtonComponent
                  label="Submit Task"
                  varient="primary"
                  className="w-100"
                  htmlType="submit"
                />
              </div>
            </Form.Item>
          </Form>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default UploadDocument;
